module.exports = __webpack_public_path__ + "static/media/starFox.f8f9f736.webp";